import { COMPANY_LOAD_INFO, COMPANY_SELECTING } from "../actions/types";
const initialState = {
	allCompany: [],
	isSaved: false,
	selectedCompanyId: "",
};
export default function (state = initialState, action) {
	switch (action.type) {
		case COMPANY_LOAD_INFO:
			return {
				...state,
				isSaved: true,
				allCompany: action.payload,
				selectedCompanyId:
					action.payload.length > 0 ? action.payload[0]._id : "",
			};
		case COMPANY_SELECTING:
			return {
				...state,
				selectedCompanyId: action.payload,
			};

		default:
			return state;
	}
}
